import React, { useState, useEffect } from "react";
import BlankLine from "./BlankLine";
import TableLine from "./TableLine";
import Global_Physical_method from "./Global_Physical_method";
import { Space, Button, Modal, Select } from "antd";
import SubstanceInfoCard from "@/Components/SubstanceInfoCard";
import { rebuildFormula } from "@/config/func";
import Content from "./Content";
import MulPropsModal from "@/Components/MulProps";
import MSelector from "./MSelector";
import { SettingOutlined } from "@ant-design/icons";
// import { getMaterials } from "@/services/propsApi";
import { useAppContext } from "@/AppContext";
import { getFlow, updateFlow } from "@/services/common";
import { getQueryString } from "@/config/func";
import { useParams } from "react-router-dom";
{/* 修改进料数据源统一注释 */}
import materialsDB from "@/constants/materialsDB";

const Component = (props: any) => {
  const {
    mParams,
    globle_physical_method,
    userInfo,
    setShowMaterialsData,
  } = props;

  const [selectedMaterials, setSelectedMaterials] = useState<number[]>([]);
  const [isModalOpen2, setIsModalOpen2] = useState(false); //闪蒸open
  const [flash, setFlash] = useState<any[]>([]); //选择的闪蒸数据
  const [curSource, setCurSource] = useState<any>(null); //当前选择的组分
  const [isModalOpen, setIsModalOpen] = useState(false); //物性数据
  const [showContent, setshowContent] = useState(false); //是否显示内容
  const [showMulProps, setShowMulProps] = useState(false); //是否显示混合物物性
  const [showMSelector, setShowMSelector] = useState(false); //是否物性数据选择器
  const [marValues, setMarValues] = useState([]);

  const { state, actions } = useAppContext();
  const { mSource, flowMode, materials, curFlow } = state;
  const { setMaterials, setIsHasJob, set_globle_physical_method } = actions;
  const isEditMode = flowMode !== "查看流程";
  const params = useParams(); // 从路由路径中提取参数

  useEffect(() => {
    const pid = params.k; // 对应路由中的:k（104）
    const fid = params.f;
    getFlow(pid, fid, userInfo.access_token).then((r) => {
      if (r.status === 200) {
        const { global_data, job_count } = r.data;
        setMaterials(global_data?.materials ? global_data.materials : []);
        setIsHasJob(job_count > 0);
        set_globle_physical_method(global_data?.globle_physical_method || globle_physical_method);
      }
    });
  }, [curFlow.id]);

  // 处理复选框变更
  const handleMaterialSelect = (index: number, isChecked: boolean) => {
    if (isChecked) {
      // 检查是否已选两个，若是则不添加
      if (selectedMaterials.length >= 2) return;
      setSelectedMaterials([...selectedMaterials, index]);
    } else {
      // 取消选择
      setSelectedMaterials(selectedMaterials.filter((i) => i !== index));
    }
  };

  // 二元闪蒸disable - check
  const canViewBinaryDiagram = selectedMaterials.length === 2;
  const mulProps = materials.length > 1;

  // 查看二元闪蒸相图
  const handleViewDiagram = () => {
    if (canViewBinaryDiagram) {
      // 获取选中的两个物质
      const selected = selectedMaterials.map((index) => materials[index]);
      setIsModalOpen2(true);
      setFlash(selected);
    }
  };

  const calMulProps = () => {
    setShowMulProps(true);
  };

  return (
    <div className="subpage">
      <div
        className="mt4"
        style={{
          display: "flex",
          justifyContent: "start",
          textAlign: "left",
        }}
      >
        <div className="subpageTitle">全局物性方法：</div>
        <Global_Physical_method
          disabled={!isEditMode}
          globle_physical_method={globle_physical_method}
          set_globle_physical_method={set_globle_physical_method}
        />
      </div>

      <div className="subpageTitle">
        {isEditMode && (
          <Space>
          设置进料：
          <Button
            type="primary"
            icon={<SettingOutlined />}
            onClick={() => setShowMSelector(true)}
            disabled={!isEditMode}
          >
            批量设置进料
          </Button>
        </Space>
        )}       
      </div>

      <div className="subpageTitle" style={{ display: "flex" }}>
        <div className="indexTable autoTable">
          <table>
            <thead>
              <tr>
                {/* 修改进料数据源统一注释 */}
                {/* <th>选择</th> */}
                <th>组分</th>
                <th>名称</th>
                <th>分子式</th>
                <th>英文名称</th>
                <th>CAS号</th>
                {isEditMode && (
                  <th>操作</th>
                )}
              </tr>
            </thead>
            <tbody>
              {materials.length > 0
                ? materials.map((item: any, index: any) => {
                  return (
                    <TableLine
                      key={index}
                      source={item}
                      setCurSource={setCurSource}
                      setIsModalOpen={setIsModalOpen}
                      isSelected={selectedMaterials.includes(index)}
                      onSelect={(checked: boolean) =>
                        handleMaterialSelect(index, checked)
                      }
                      maxSelected={selectedMaterials.length >= 2}
                    />
                  );
                })
                : ""}

              {flowMode !== "查看流程" ? (
                <BlankLine
                  userInfo={userInfo}
                  mParams={mParams}
                  materials={materials}
                  setMaterials={setMaterials}
                  // {/* 修改进料数据源统一注释 */}
                  // alldata={mSource}
                  alldata={materialsDB}
                />
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
      {/* 修改进料数据源统一注释 */}
      {/* <Space>
        <Button
          disabled={!mulProps}
          onClick={calMulProps}
          style={{ marginTop: "16px" }}
        >
          混合物物性计算
        </Button>
        <Button
          disabled={!canViewBinaryDiagram}
          onClick={handleViewDiagram}
          style={{ marginTop: "16px" }}
        >
          查看二元闪蒸相图
        </Button>
      </Space> */}

      {flash.length > 1 ? (
        <Modal
          width={800}
          footer={null}
          open={isModalOpen2}
          style={{ top: "3rem" }}
          onCancel={() => {
            setIsModalOpen2(false);
            setshowContent(false)
            // setFlash([]);
          }}
          // destroyOnHidden
          // onClose={() => setshowContent(false)}
          afterOpenChange={() => setshowContent(true)}
          title={`${flash[0]?.name} 与 ${flash[1]?.name} 的二元闪蒸相图`}
        >
          {/* <Select
            placeholder="切换物质"
            options={[
              { value: 1, label: "1" },
              { value: 2, label: "2" },
            ]}
          /> */}
          {showContent ? <Content status={isModalOpen2} showContent={showContent} source={flash} /> : ""}
        </Modal>
      ) : null}
      <MSelector
        status={showMSelector}
        setStatus={setShowMSelector}
        materials={materials}
        setMaterials={setMaterials}
        // {/* 修改进料数据源统一注释 */}
        // source={mSource}
        source={materialsDB}
      />
      <MulPropsModal
        status={showMulProps}
        setStatus={setShowMulProps}
        source={materials}
        marValues={marValues}
      />

      <Modal
        width="70%"
        style={{ top: "20px" }}
        footer={null}
        maskClosable={false}
        keyboard={false}
        destroyOnHidden={true}
        open={isModalOpen}
        title={
          curSource ? (
            <div className="t1">
              {curSource.name} {rebuildFormula(curSource.formula)}
            </div>
          ) : (
            ""
          )
        }
        onCancel={() => setIsModalOpen(false)}
      >
        <SubstanceInfoCard source={curSource} />
      </Modal>
    </div>
  );
};

export default Component;
